window.videoModal;
window.videoModalButton;
window.videoModal = document.getElementById('video-modal');
window.videoIframe = videoModal ? videoModal.querySelector('figure.video video') : false;

[].slice.call(document.querySelectorAll('.video-modal-button')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {

		videoIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
		videoIframe.setAttribute('class', 'video');
		videoIframe.setAttribute('allowfullscreen', true);
		videoIframe.src = this.dataset.src ? this.dataset.src : this.nextSibling.firstChild.dataset.src 
        videoModalButton = this;

		Velocity(videoModal, {opacity: [1,0]}, {duration: 300, display: 'block'});

		setTimeout(function() {
			videoIframe.play();
			videoModal.querySelector('.close-modal').focus();
			skipLinkToggleDisplay(true);
			setFocus(true, false);
		}, 300);

        videoIframe.setAttribute('title', this.querySelector('h3').innerHTML);
	});
});

var modals = [].slice.call(document.querySelectorAll('div[role="dialog"]'));

modals.forEach(function (modal) {
	modal.addEventListener('click', function (e) {
		if (e.target == modal.querySelector('button') || !modal.querySelector('.content').contains(e.target)) closeModal();
	});
});

function closeModal() {
	modals.forEach(function(modal) {
		if(window.getComputedStyle(modal).display == 'block')
			Velocity(modal, {opacity: [0,1]}, {duration: 300, display: 'none'});

		if(modal == videoModal) {
			setTimeout(function() {
				videoIframe.pause();
			}, 300);
		}
	});
}